// utility hook so we can use a curried logging function in useEffect without having to memoize it every time
// If anyone wants to take a stab at typing this, please do.
import * as React from 'react';
import { logger } from '../lib/logger';

export const useLogger = action => {
  return React.useMemo(() => logger(action), [action]);
};
